export const TRANSLATION_KEYS = {
  fieldLabel: 'partnerbasicinfo-ticker-field-retail',
  tickerLabel: 'partnerbasicinfo-ticker-retail',
}
